export default __webpack_public_path__ + "static/media/run.d3335990.png";